import { Controller } from "@hotwired/stimulus"

// Polls the S&W device-code status endpoint every few seconds until
// Microsoft confirms sign-in (or the code expires/errors), then redirects to
// the calendar page. See docs/plans/2026-09-27-savant-scheduling.md, PR A.
export default class extends Controller {
  static targets = ["status"]
  static values = { pollUrl: String, redirectUrl: String, intervalMs: { type: Number, default: 5000 } }

  connect() {
    this.poll()
  }

  disconnect() {
    if (this.timeoutId) clearTimeout(this.timeoutId)
  }

  async poll() {
    try {
      const response = await fetch(this.pollUrlValue, { headers: { Accept: "application/json" } })
      const data = await response.json()

      if (data.status === "connected") {
        this.setStatus("Connected. Redirecting…")
        window.location.href = this.redirectUrlValue
        return
      }
      if (data.status === "expired") {
        this.setStatus("This code expired. Reload the page to try again.")
        return
      }
      if (data.status === "error") {
        this.setStatus(data.message || "Something went wrong. Reload the page to try again.")
        return
      }
    } catch (_error) {
      // transient network hiccup — keep polling
    }
    this.timeoutId = setTimeout(() => this.poll(), this.intervalMsValue)
  }

  setStatus(text) {
    if (this.hasStatusTarget) this.statusTarget.textContent = text
  }
}
